/**
 * Copies a discount code to the clipboard and reports back on the element itself,
 * so the visual feedback lives entirely in CSS.
 */
class CopyCode extends HTMLElement {
  /** @type {number} */
  #resetTimer = 0;

  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', () => this.#copy());
  }

  disconnectedCallback() {
    clearTimeout(this.#resetTimer);
  }

  async #copy() {
    const code = this.dataset.code;

    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch {
      // clipboard API needs a secure context and permission — fall back to a throwaway field
      const field = document.createElement('textarea');

      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    const status = this.querySelector('[role="status"]');

    this.toggleAttribute('data-copied', true);
    if (status) status.textContent = `Copied ${code}`;

    clearTimeout(this.#resetTimer);
    this.#resetTimer = setTimeout(() => {
      this.toggleAttribute('data-copied', false);
      if (status) status.textContent = '';
    }, 2000);
  }
}

if (!customElements.get('copy-code')) {
  customElements.define('copy-code', CopyCode);
}
